export default {
    twilio_received_a_delivery_receipt_indicating_that_the_outbound_message_was_not_delivered:
        'Twilio received a delivery receipt indicating that the outbound message was not delivered.',
    twilio_has_received_information_of_outbound_message_failed_to_send:
        'Twilio has received information of outbound message failed to send.',
    server_error: 'Server Error',
    invalid_number_format: 'Invalid number format',
    error_during_creating_meeting: 'Error during creating meeting. Please try again later...',
    meeting_has_been_added: 'Meeting has been added',
    something_went_wrong: 'something went wrong',
}
